import {radarRequest} from './radarApi';
import type {RadarCandidate, RadarFeedback} from './types';

export type ExpoInput = {product:string;market:string;relationship:string;website?:string;notes?:string};
export type ExpoConversation = {
  id:string;workspace_id:string;search_run_id:string;input:ExpoInput;
  search_status:'queued'|'processing'|'ready'|'failed';result_count:number;search_error?:string|null;
  recipient_email:string|null;mail_status:'none'|'queued'|'sending'|'sent'|'failed'|'uncertain';mail_error?:string|null;
  trial_searches:number;claimed_at:string|null;created_at?:string;
  round_number?:1|2;batch_feedback?:string|null;first_search_run_id?:string|null;mail_round_number?:1|2|null;
  first_round_candidates?:RadarCandidate[];
  candidates?:RadarCandidate[];feedback?:Array<RadarFeedback & {candidate_id:string}>;
};
const root='/api/radar/expo/sessions';
export const expoApi={
  list:(token:string,offset=0)=>radarRequest<{sessions:ExpoConversation[];next_offset:number|null}>(`${root}?offset=${offset}`,token,{cache:'no-store'}),
  detail:(token:string,id:string)=>radarRequest<ExpoConversation>(`${root}/${encodeURIComponent(id)}`,token,{cache:'no-store'}),
  create:(token:string,input:ExpoInput,key:string)=>radarRequest<{id:string}>(root,token,
    {method:'POST',headers:{'Idempotency-Key':key},body:JSON.stringify(input)}),
  capture:(token:string,id:string,email:string)=>radarRequest<{id:string}>(`${root}/${encodeURIComponent(id)}/email`,token,
    {method:'POST',body:JSON.stringify({email})}),
  retrySearch:(token:string,id:string,key:string)=>radarRequest<{id:string}>(`${root}/${encodeURIComponent(id)}/retry-search`,token,
    {method:'POST',headers:{'Idempotency-Key':key}}),
  refine:(token:string,id:string,feedback:string,key:string)=>radarRequest<{id:string}>(`${root}/${encodeURIComponent(id)}/refine`,token,
    {method:'POST',headers:{'Idempotency-Key':key},body:JSON.stringify({feedback})}),
  retryMail:(token:string,id:string)=>radarRequest<{id:string}>(`${root}/${encodeURIComponent(id)}/retry-mail`,token,{method:'POST'}),
  claim:(token:string,id:string)=>radarRequest<{workspace_id:string;searches_remaining:number}>(`${root}/${encodeURIComponent(id)}/claim`,token,{method:'POST'}),
};
